module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save":"Save","cancel":"Cancel","h1":"Edit page"}}')
  delete Component.options._Ctor
}
